import { render, staticRenderFns } from "./authorities.vue?vue&type=template&id=6705c0ee"
import script from "./authorities.vue?vue&type=script&lang=js"
export * from "./authorities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports